import React from "react";
import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for headlines. Pass array of lines.
export const MaskLines = ({ lines, className = "", delay = 0, start = false }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-reveal">
        <motion.span
          style={{ display: "block" }}
          initial={{ y: "110%" }}
          animate={start ? { y: 0 } : undefined}
          whileInView={start ? undefined : { y: 0 }}
          viewport={start ? undefined : { once: true, margin: "-60px" }}
          transition={{ duration: 1, ease, delay: delay + i * 0.11 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export default Reveal;
